import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

// Re-export individual stores
export { useAssetStore } from './assetStore'
export { useAlertStore } from './alertStore'
export { usePredictionStore } from './predictionStore'
export { useUIStore } from './uiStore'
export { useComparisonStore } from './comparisonStore'

// Combined store type for cross-store access if needed
export interface AppState {
  isInitialized: boolean
  setInitialized: (value: boolean) => void
}

export const useAppStore = create<AppState>()(
  devtools(
    (set) => ({
      isInitialized: false,
      setInitialized: (value) => set({ isInitialized: value })
    }),
    { name: 'app-store' }
  )
)
